
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tblCycleCountTask/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblCycleCountTask/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblCycleCountTask/findPage',
        method: 'post',
      data
    })
}

// 按库区库位和商品生成盘点任务
export const generateCountTaskByLocItem = (data) => {
  return axios({
    url: '/tblCycleCountTask/generateCountTaskByLocItem',
    method: 'post',
    data
  })
}

// 按SKU百分比生成盘点任务
export const generateCountTaskByPercent = (data) => {
  return axios({
    url: '/tblCycleCountTask/generateCountTaskByPercent',
    method: 'post',
    data
  })
}

// 按事务类型生成盘点任务
export const generateCountTaskByTranType = (data) => {
  return axios({
    url: '/tblCycleCountTask/generateCountTaskByTranType',
    method: 'post',
    data
  })
}

// 按盘点单号生成调整单
export const generateAdjustmentTask = (data) => {
  return axios({
    url: '/tblCycleCountTask/generateAdjustmentTask',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblCycleCountTask.js